export default{
    billRow: {
        index: 'bill-row-index',
    }
}